import FeedbackPage from '@app-studio-web/ui/pages/FeedbackPage'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

export default function FeedbackBiggestChallengeIntroPage() {
  const navigate = useNavigate()
  const { t } = useTranslation()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    navigate('/onboarding/question-biggest-challenge')
  }

  return (
    <FeedbackPage
      emoji="🌿"
      heading={t('pages.onboarding.feedbackBiggestChallengeIntro.heading')}
      text={t('pages.onboarding.feedbackBiggestChallengeIntro.text')}
      onSubmit={handleSubmit}
    />
  )
}
